import { Component, OnInit, Input } from '@angular/core';

import { MailInfo } from './../../../model/mail-info.model';
import { ActionLogForOffer } from '../../../model/action-log-for-offer.model';
@Component({
  selector: 'app-card-offer-page-header',
  templateUrl: './card-offer-page-header.component.html',
  styleUrls: ['./card-offer-page-header.component.scss']
})
export class CardOfferPageHeaderComponent implements OnInit {
  constructor() {}
  @Input() mailInfo: MailInfo;
  @Input() mailType: string;
  @Input() page: string; // 存在するページ
  @Input() offer: any;
  @Input() actionLog: ActionLogForOffer;
  @Input() haveSkillList: boolean;
  pairIdLength = 5;

  ngOnInit() {}
  // transform offer id to base 26 when user wise id is unavailable
  decToBase26(decNumber: number): string {
    const base = 26;
    const remStack = [];
    const digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let number = decNumber;
    let rem: number;
    let baseString = '';
    while (number > 0) {
      rem = Math.floor(number % base);
      remStack.push(digits[rem]);
      number = Math.floor(number / base);
    }
    remStack.push('A');
    while (remStack.length > 0) {
      baseString += remStack.pop();
    }
    if (baseString.length < this.pairIdLength) {
      baseString = ('AAAAA' + baseString).slice(-this.pairIdLength);
    }

    return baseString;
  }
  base26ToDec(numberString: string): number {
    const numbers = numberString.split('').reverse();
    let decimal = 0;
    for (let i = 0; i < numbers.length; i++) {
      const element = numbers[i].charCodeAt(0) - 'A'.charCodeAt(0);
      decimal += element * 26 ** i;
    }
    return decimal;
  }
  getID() {
    // 0 はifでfalseに判定されるため
    return this.offer.user_wise_id === 0 || this.offer.user_wise_id
      ? this.offer.user_wise_id
      : this.decToBase26(this.offer.id);
  }
}
